import { RouteConfig } from "vue-router";

export const RRegistration: RouteConfig = {
  path: "registration",
  name: "Registration",
  component: () =>
    import(
      /* webpackChunkName: "auth-registration" */
      "./VRegistration.vue"
    ),
};
